import { render, staticRenderFns } from "./SelectStorageName.vue?vue&type=template&id=48c91750&scoped=true&"
import script from "./SelectStorageName.vue?vue&type=script&lang=js&"
export * from "./SelectStorageName.vue?vue&type=script&lang=js&"
import style0 from "./SelectStorageName.vue?vue&type=style&index=0&id=48c91750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c91750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
